import React from "react";
import { motion } from "framer-motion";
import { Heart, ArrowUpRight, Users } from "lucide-react";
import Modal from "../../../components/common/Modal";
import VoterAvatars from "./VoterAvatars";
import { useTranslation } from "react-i18next";

const ProfileDetailModal = ({ open, selectedIdea, onClose, handleVote, votedIdeas, showToast }) => {
  const { t } = useTranslation();

  const headerContent = (
    <div>
      <motion.h2
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, duration: 0.4 }}
        className="tw-bg-gradient-to-r tw-from-gray-900 tw-to-gray-600 tw-bg-clip-text tw-text-2xl tw-font-bold tw-text-transparent"
      >
        {selectedIdea?.name || t("singles_inferno.no_name")}
      </motion.h2>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.4 }}
        className="tw-mt-2 tw-flex tw-items-center tw-space-x-2"
      >
        <span className="tw-text-sm tw-text-gray-500">
          {t("singles_inferno.posted_by", {
            author: selectedIdea?.author || t("singles_inferno.anonymous"),
          })}
        </span>
      </motion.div>
    </div>
  );

  return (
    <Modal open={open} onClose={onClose} headerContent={headerContent} maxHeight="80vh">
      {selectedIdea?.images && selectedIdea.images.length > 0 && (
        <div className="tw-mb-6 tw-grid tw-grid-cols-1 tw-gap-4 md:tw-grid-cols-2">
          {selectedIdea.images.map((image, index) => (
            <div key={index} className="tw-h-64 tw-overflow-hidden tw-rounded-xl">
              <img
                src={image}
                alt={`${selectedIdea.name} - 圖片 ${index + 1}`}
                className="tw-h-full tw-w-full tw-object-cover"
              />
            </div>
          ))}
        </div>
      )}

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5, duration: 0.4 }}
        className="tw-mb-8 tw-pr-2"
      >
        {selectedIdea?.description ? (
          <p className="tw-whitespace-pre-line tw-text-gray-600">{selectedIdea.description}</p>
        ) : (
          <p className="tw-italic tw-text-gray-400">未提供描述</p>
        )}
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.6, duration: 0.4 }}
        className="tw-flex tw-flex-col tw-space-y-4"
      >
        <div className="tw-flex tw-items-center tw-justify-between">
          <div className="tw-flex tw-items-center tw-space-x-4">
            <motion.button
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              onClick={() => {
                if (selectedIdea?.id) {
                  handleVote(selectedIdea?.id);
                } else {
                  showToast(t("singles_inferno.no_idea"), "error");
                }
              }}
              className="tw-flex tw-items-center tw-space-x-2 tw-rounded-full tw-bg-rose-50 tw-px-4 tw-py-2 tw-transition-colors hover:tw-bg-rose-100"
            >
              <Heart
                className={`tw-h-5 tw-w-5 ${
                  selectedIdea?.id && votedIdeas.has(selectedIdea.id)
                    ? "tw-fill-rose-500 tw-text-rose-500"
                    : "tw-text-rose-500"
                }`}
              />
              <span className="tw-font-medium tw-text-rose-500">
                {selectedIdea?.id && votedIdeas.has(selectedIdea.id)
                  ? t("singles_inferno.voted")
                  : t("singles_inferno.vote")}
              </span>
            </motion.button>
            <p className="tw-text-gray-500">
              {selectedIdea?.voters.length}{" "}
              {selectedIdea?.voters.length === 1
                ? t("singles_inferno.vote_singular")
                : t("singles_inferno.vote_plural")}
            </p>
          </div>
        </div>

        {selectedIdea?.voters.length > 0 && (
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.7 }}
            className="tw-rounded-xl tw-bg-gray-50 tw-p-4"
          >
            <div className="tw-mb-3 tw-flex tw-items-center tw-space-x-3">
              <Users className="tw-h-5 tw-w-5 tw-text-gray-500" />
              <span className="tw-font-medium tw-text-gray-700">
                {t("singles_inferno.supporters")}
              </span>
            </div>
            <VoterAvatars voters={selectedIdea.voters} maxDisplay={8} />
            {selectedIdea.voters.length > 8 && (
              <p className="tw-mt-2 tw-text-sm tw-text-gray-500">
                {t("singles_inferno.more_supporters", {
                  count: selectedIdea.voters.length - 8,
                })}
              </p>
            )}
          </motion.div>
        )}
      </motion.div>
    </Modal>
  );
};

export default ProfileDetailModal;
